<template>
    <div class="tab-pane active">
        <div class="modal_content clearfix p-20" v-if="!showForm && !showWForm">
            <span class="btn btn-xs btn_green m-t-10 pull-right" @click="collapseAll" v-pml-tooltip="$t('collapse_all')" v-if="!collapsedAll"><i class="glyphicon glyphicon-resize-small"></i></span>
            <span class="btn btn-xs btn-primary m-t-10 pull-right" @click="expandAll" v-pml-tooltip="$t('expand_all')" v-if="collapsedAll"><i class="glyphicon glyphicon-resize-full"></i></span>
            <button class="btn btn-default" @click="showForm = !showForm" v-if="deal.editable">
                <span class="btn-label">
                    <i class="fa fa-plus-circle"></i>
                </span>
                {{ $t('follow_up') }}
            </button>
            <button class="btn btn-default" @click="showWForm = !showWForm" v-if="deal.editable">
                <span class="btn-label">
                    <i class="fa fa-plus-circle"></i>
                </span>
                {{ $t('whatsapp_follow_up') }}
            </button>
        </div>
        <form @submit.prevent="store" class="modal_content p-20" v-if="showWForm">
            <div class="row form-group">
                <div class="col-md-12" :class="{ 'has-error': errors['content'] }">
                    <label>{{ $t('comments') }} </label>
                    <textarea v-model="record.content" v-pml-focus v-pml-autosize class="form-control" rows="4"></textarea>
                    <span class="error" v-if="errors['content']">{{ errors['content'][0] }}</span>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-6" :class="{ 'has-error': errors['access_way_id'] }">
                    <label>{{ $t('access_way') }}</label>
                    <pml-select v-model="record.access_way_id" :options="accessWays()"></pml-select>
                    <span class="error" v-if="errors['access_way_id']">{{ errors['access_way_id'][0] }}</span>
                </div>
                <div class="col-sm-6 m-t-23 t_right">
                    <span class="btn btn-white" @click="closeForm">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </div>
        </form>
        <form @submit.prevent="store" class="modal_content p-20" v-if="showForm">
            <div class="row form-group">
                <div class="col-md-12" :class="{ 'has-error': errors['content'] }">
                    <label>{{ $t('comments') }} </label>
                    <textarea v-model="record.content" v-pml-focus v-pml-autosize class="form-control" rows="4"></textarea>
                    <span class="error" v-if="errors['content']">{{ errors['content'][0] }}</span>
                </div>
            </div>
            <div class="row form-group">
                <div class="col-sm-6" :class="{ 'has-error': errors['access_way_id'] }">
                    <label>{{ $t('access_way') }}</label>
                    <pml-select v-model="record.access_way_id" :options="accessWays()"></pml-select>
                    <span class="error" v-if="errors['access_way_id']">{{ errors['access_way_id'][0] }}</span>
                </div>
                <div class="col-sm-6 m-t-23 t_right">
                    <span class="btn btn-white" @click="closeForm">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </div>
        </form>
        <div class="p-30">
            <div class="history_deal" v-for="(item, index) in followUps">
                <PmlItem :item="item"></PmlItem>
            </div>
            <div v-if="!followUps.length">
                <p class="t_center"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import PmlItem from './Item.vue'
    import bus from 'utils/events/bus'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { mapGetters } from 'vuex'
    import { create } from 'services/follow-ups'
    import { find } from 'lodash'

    export default {
        name: 'FollowUps',
        components: { PmlItem },
        data () {
            return {
                isSaving: false,
                showForm: false,
                showWForm: false,
                collapsedAll: true,
                record: {
                    access_way_id: ''
                },
                errors: []
            }
        },
        computed: {
            ...mapGetters({
                'accessWays': 'getActiveAccessWays',
                'member': 'getMember',
                'deal': 'getDealInfo',
                'followUps': 'getDealFollowUps'
            })
        },
        watch: {
            showWForm () {
                if (this.showWForm) {
                    this.record.whatsapp = true
                    const accessWay = find(this.accessWays(), item => item.name.toLowerCase() === 'whatsapp')
                    this.record.access_way_id = accessWay ? accessWay.id : ''
                }
            }
        },
        methods: {
            clearForm () {
                this.record = {
                    access_way_id: ''
                }
                this.errors = []
            },
            closeForm () {
                this.showForm = false
                this.showWForm = false
                this.clearForm()
            },
            store () {
                this.record.member_id = this.member.id
                this.record.type = 'message'

                this.isSaving = true

                create(this.deal.id, this.record)
                    .then(() => {
                        Notify.success(trans('the_record_has_been_saved'))
                        this.closeForm()
                    })
                    .catch(error => { this.errors = error.response.data.errors || [] })
                    .then(() => { this.isSaving = false })
            },
            collapseAll () {
                this.collapsedAll = true
                bus.$emit('collapseFollowUp')
            },
            expandAll () {
                this.collapsedAll = false
                bus.$emit('expandFollowUp')
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/follow_ups/Main.vue